module.exports = __webpack_public_path__ + "img/ac12_thumb.f6220c89.jpg";